module.exports = __webpack_public_path__ + "img/prizeScale.0076df7d.png";